<template>
    <div class="home-invest-button">
        <div class="home-invest-button__main">
            <ui-button
                v-bind:href="loginUrl"
                theme="primary"
                size="huge"
                v-bind:is-uppercase="false"
                is-width-free
            >
                Начать инвестировать
            </ui-button>
        </div>
        <div class="home-invest-button__mobile">
            <ui-button
                v-bind:href="loginUrl"
                theme="primary"
                size="lg"
                v-bind:is-uppercase="false"
                is-width-free
            >
                Начать инвестировать
            </ui-button>
        </div>
    </div>
</template>

<script>
import config from '~/config';

export default {
    name: 'home-invest-button',
    data: () => ({
        loginUrl: config.urls.auth.login,
    }),
};
</script>

<style scoped lang="less">
@import '~theme';

.home-invest-button {
    &__mobile {
        display: none;
    }

    @media @media-md-down {
        &__main {
            display: none;
        }
        &__mobile {
            display: block;
        }
    }
}
</style>
